import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, useTheme } from '@mui/material';
import React from 'react';

const activeItemStyle = {
  bgcolor: 'primary.alpha.lighter',
  color: 'primary.main',
};

function childItemLineStyle(shortenedLine, color) {
  return shortenedLine
    ? {
        border: 'solid transparent',
        borderWidth: '0 0 0 1px',
        borderImage: `linear-gradient(180deg,${color} 0%, ${color} 75%, rgba(0,0,0,0) 75%)`,
        borderImageSlice: 1,
      }
    : {
        borderLeft: '1px solid',
        borderColor: 'primary.main',
      };
}

export default function Row({
  icon,
  label,
  open,
  expandable = false,
  isChild = false,
  lastChild = false,
  active = false,
  level = 0,
}) {
  const indent = level ? 5 + 20 * level : 0;

  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: '12px 16px',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'neutrals.dark',
        textDecoration: 'none !important',
        transitionProperty: 'color, background',
        transitionDuration: '500ms',
        '&:focus-visible': {
          backgroundColor: 'primary.alpha.lighter',
          boxShadow: `inset 8px 0 ${theme.palette.primary.main}`,
          color: 'primary.main',
        },
        '&:hover': {
          backgroundColor: 'primary.alpha.lighter',
          color: 'primary.main',
        },
        whiteSpace: 'nowrap',
        ...(active && activeItemStyle),
        marginLeft: `${indent}px`,
        ...(isChild &&
          childItemLineStyle(lastChild || open, theme.palette.primary.main)),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          height: '100%',
        }}
      >
        {!!icon && icon}

        <Box sx={{ marginLeft: '16px' }}>{label}</Box>
      </Box>

      {expandable && (
        <ExpandMoreIcon
          sx={{
            transform: open ? 'rotate(-180deg)' : 'rotate(0)',
            transitionProperty: 'transform',
          }}
        />
      )}
    </Box>
  );
}
